<template>
  <div>
    <v-card class="pa-3">
      <div class="text-xs-right">
        <v-btn flat icon ripple @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <div class="py-2">
        <div class="mt-2">
          <div class="caption">Ticket ID:</div>
          <div class="form-control">
            <input v-model="input.ticket_id" :placeholder="'Ticket ID'" type="text" />
          </div>
        </div>
        <div class="mt-2">
          <div class="caption">Ticket Name:</div>
          <div class="form-control">
            <input v-model="input.ticket_name" :placeholder="'Ticket Name'" type="text" />
          </div>
        </div>
        <div class="mt-2">
          <div class="caption">Group:</div>
          <div class="form-control mb-2">
            <multiselect
              v-model="input.group"
              :max-height="250"
              :options="agentGroupOptions"
              :placeholder="'Group'"
              label="groupname"
            >
            </multiselect>
          </div>
        </div>
        <div class="mt-2">
          <div class="caption">SubGroup:</div>
          <div class="form-control mb-2">
            <multiselect
              v-model="input.subgroup"
              :max-height="250"
              :options="agentSubGroupOptions"
              :placeholder="'SubGroup'"
              label="subgroupname"
            >
            </multiselect>
          </div>
        </div>
        <div class="mt-2">
          <div class="caption">Agent:</div>
          <div class="form-control">
            <multiselect
              v-model="input.agent_name"
              :custom-label="formatOption"
              :max-height="250"
              :open-direction="'above'"
              :options="agentOptions"
              :placeholder="'Agent'"
            >
            </multiselect>
          </div>
        </div>
        <div class="mt-2">
          <div class="caption">{{ $t('phone no.') }}</div>
          <div class="form-control">
            <input v-model="input.phone_number" :placeholder="$t('phone no.')" type="text" />
          </div>
        </div>
        <div class="mt-2">
          <div class="caption">{{ $t('Tags') }}</div>
          <multiselect
            v-model="input.tags"
            :multiple="true"
            :options="tagOptions"
            :placeholder="$t('Tags')"
            :taggable="true"
            @tag="addTag"
          >
          </multiselect>
        </div>
        <div class="mt-2">
          <v-layout>
            <v-flex class="pa-1">
              <v-btn block depressed @click="clearSearch">
                <v-icon>clear</v-icon>
                {{ $t('Clear All') }}
              </v-btn>
            </v-flex>
            <v-flex class="pa-1">
              <v-btn block color="primary" depressed @click="onSearch">
                <v-icon>search</v-icon>
                {{ $t('Search') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import api from '@/api'
import { PAGE_GROUP } from '@/constants/page.js'

export default {
  components: {
    Multiselect
  },
  data() {
    return {
      input: {
        ticket_id: '',
        ticket_name: '',
        group: '',
        subgroup: '',
        agent_name: '',
        phone_number: '',
        email: '',
        tags: ''
      },
      tagOptions: [],
      groupOptions: [],
      subgroupOptions: []
    }
  },
  computed: {
    ...mapGetters({
      agentGroup: 'getAgentGroup',
      agentSubGroup: 'getAgentSubgroup',
      agent: 'getAgent',
      selectedBot: 'selectedBot',
      loadingAgentGroup: 'getLoadingAgentGroup',
      loadingAgentSubGroup: 'getLoadingAgentSubgroup',
      loadingAgent: 'getLoadingAgent'
    }),
    isCIMBWealthPage() {
      return this.selectedBot.page_group === PAGE_GROUP.CIMB_WEALTH
    },
    agentGroupOptions() {
      if (this.agentGroup && this.agentGroup.length) {
        if (this.isCIMBWealthPage) {
          const adminGroupIdCurrent = this.$store.state.admingroupid
          return this.agentGroup.filter((el) => {
            return el.id === adminGroupIdCurrent
          })
        }
        return this.agentGroup
      } else {
        return []
      }
    },
    agentSubGroupOptions() {
      if (this.agentSubGroup && this.agentSubGroup.length) {
        return this.agentSubGroup
        // return this.agentSubGroup.filter((el) => {
        //   return el.admingroupid == this.transfer.group.id
        // })
      } else {
        return []
      }
    },
    agentOptions() {
      if (this.agent && this.agent.length) {
        if (this.isCIMBWealthPage) {
          if (this.input.group) {
            return this.agent.filter((el) => el.admingroupid === this.input.group.id)
          } else {
            return []
          }
        }
        return this.agent
      } else {
        return []
      }
    }
  },
  watch: {
    agentGroupOptions(groups) {
      if (this.isCIMBWealthPage && groups.length > 0) {
        this.input.group = groups[0]
      }
    }
  },
  mounted() {
    this.getUserTagList()
  },
  methods: {
    formatOption(option) {
      if (option.display_name) {
        return `${option.display_name}`
      } else {
        return `${option.adminid}`
      }
    },
    async getUserTagList() {
      var response = await api.getUserTagList()
      if (response && response.result) {
        response.result.map((item) => {
          this.tagOptions.push(item.name)
        })
      }
    },
    addTag(newTag) {
      const tag = newTag
      this.tagOptions.push(tag)
      this.input.tags.push(tag)
    },
    onSearch() {
      this.$emit('onSearch', this.input)
    },
    clearSearch() {
      this.input = {
        ticket_id: '',
        ticket_name: '',
        group: '',
        subgroup: '',
        agent_name: '',
        phone_number: '',
        email: '',
        tag: ''
      }

      this.$emit('onSearch', this.input)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/AdvancedSearch.vue